module.exports = __webpack_public_path__ + "img/product_cover.b5fbb4b7.png";